import {
  GET_DETAILS,
  UPDATE_SITE_CONTACT,
  UPDATE_STREET_VIEW
} from "./jobActionTypes";

const jobReducer = (state, action) => {
  switch (action.type) {
    case GET_DETAILS:
      return { ...state, details: action.payload };
    case UPDATE_SITE_CONTACT:
      return { ...state, details: { ...state.details, siteContact: action.payload.siteContact, siteContactNotes: action.payload.siteContactNotes, siteContactPhone: action.payload.siteContactPhone } };
    case UPDATE_STREET_VIEW:
      console.log("streetView", action.payload);
      return { ...state, details: { ...state.details, streetViewImage: action.payload } };
    default:
      return state;
  }
};


export default jobReducer;
